function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgotPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 290.98 323.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 298.4,
    width: 23.31,
    height: 0.23,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "87.7 212.74 26.9 212.74 23.21 170.16 84.01 170.16 87.7 212.74",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.85 212.74 30.05 212.74 26.36 170.16 87.16 170.16 90.85 212.74",
    style: {
      fill: "#f1f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.36 203.6 36.33 179.31 78.84 179.31 80.87 203.6 38.36 203.6",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 34.57,
    y: 212.74,
    width: 69.05,
    height: 8.77,
    transform: "translate(138.19 434.25) rotate(180)",
    style: {
      fill: "#f1f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.75,173.51c.3-4.26,7.09-12.07,23.43-8.52,11.82,2.57,16.21-3.55,16.21-3.55,0,0-1.09,17.29-18.86,22.48-16.87,4.94-21.29-2.93-20.77-10.41Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48,199.68c.18,0,.36-.08,.48-.22,1.18-1.4,.22-4.75-1.13-9.39-1.72-5.96-3.86-13.37-2.05-18.75,1.02-3.04,2.29-5.72,3.52-8.31,2.56-5.42,4.78-10.11,2.93-15-.12-.33-.49-.49-.81-.37-.33,.12-.49,.49-.37,.81,1.66,4.39-.35,8.64-2.89,14.02-1.18,2.5-2.52,5.34-3.57,8.44-1.94,5.76,.26,13.38,2.03,19.5,1.04,3.61,2.12,7.34,1.37,8.23-.22,.27-.19,.66,.07,.89,.12,.1,.26,.15,.41,.15Z",
    style: {
      fill: "#e6e6e6"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "137.14 272.61 7.12 272.61 0 63.5 130.03 63.5 137.14 272.61",
    style: {
      fill: "#006838"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.63 266.12 13.61 266.12 6.49 57.01 136.52 57.01 143.63 266.12",
    style: {
      fill: "#39b54a"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.54,
    cy: 116.99,
    rx: 35.96,
    ry: 37.2,
    transform: "translate(-61.44 87.41) rotate(-45.49)",
    style: {
      fill: "#006838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,116.98c.18,5.21-.98,10.11-3.16,14.38-4.77,9.41-14.52,15.81-26,15.81s-21.66-6.4-27.08-15.81c-2.47-4.27-3.96-9.17-4.14-14.38-.57-16.67,12.48-30.19,29.16-30.19s30.65,13.51,31.21,30.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.57,131.36c-4.77,9.41-14.52,15.81-26,15.81s-21.66-6.4-27.08-15.81c7.43-5.08,16.45-8.04,26.26-8.04s19.04,2.96,26.81,8.04Z",
    style: {
      fill: "#006838",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.19,
    cy: 106.66,
    rx: 13.22,
    ry: 13.68,
    transform: "translate(-54.18 84.07) rotate(-45.49)",
    style: {
      fill: "#006838",
      opacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "117.52 190.4 34.57 190.4 34.01 173.91 116.95 173.91 117.52 190.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.52 219.86 35.57 219.86 35.01 203.37 117.96 203.37 118.52 219.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.51,205.64l-19.99,2.72c-.82,.11-1.36,.86-1.21,1.65l2.62,13.39c.16,.8,.95,1.36,1.78,1.25l19.99-2.72c.82-.11,1.36-.85,1.21-1.65l-2.62-13.39c-.16-.79-.95-1.36-1.77-1.25Zm-5.74,13.57l-3.62,.49-.36-4.32c-.77-.34-1.33-1.02-1.49-1.83-.26-1.31,.63-2.52,1.97-2.71,1.34-.18,2.64,.73,2.9,2.04,.16,.8-.11,1.6-.71,2.13l1.31,4.19Z",
    style: {
      fill: "#006838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.53,204.92h0c-.73,.1-1.44-.4-1.57-1.11l-.26-1.31c-.71-3.61-4.16-6.33-7.89-6.01-3.99,.35-6.67,3.87-5.92,7.69l.3,1.51c.14,.71-.34,1.37-1.07,1.47h0c-.73,.1-1.44-.4-1.57-1.11l-.25-1.28c-.99-5.03,2.18-9.86,7.3-10.75,5.38-.94,10.69,2.69,11.72,7.93l.3,1.51c.14,.71-.34,1.37-1.07,1.47Z",
    style: {
      fill: "#006838"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.83 242.94 50.83 242.94 50.47 232.21 104.46 232.21 104.83 242.94",
    style: {
      fill: "#006838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.78,182.15c.06,1.67-1.25,3.01-2.91,3.01s-3.06-1.35-3.12-3.01c-.06-1.66,1.25-3.01,2.91-3.01s3.06,1.35,3.12,3.01Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8,182.15c.06,1.67-1.25,3.01-2.91,3.01s-3.06-1.35-3.12-3.01c-.06-1.66,1.25-3.01,2.91-3.01s3.06,1.35,3.12,3.01Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.82,182.15c.06,1.67-1.25,3.01-2.91,3.01s-3.06-1.35-3.12-3.01c-.06-1.66,1.25-3.01,2.91-3.01s3.06,1.35,3.12,3.01Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.75,182.15c.06,1.67-1.25,3.01-2.91,3.01s-3.06-1.35-3.12-3.01c-.06-1.66,1.25-3.01,2.91-3.01s3.06,1.35,3.12,3.01Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.73,182.15c.06,1.67-1.25,3.01-2.91,3.01s-3.06-1.35-3.12-3.01c-.06-1.66,1.25-3.01,2.91-3.01s3.06,1.35,3.12,3.01Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M214.02,101.59c1.22,1.95,2.23,3.83,3.28,5.78,1.04,1.93,1.99,3.91,2.91,5.91,1.82,4.01,3.45,8.15,4.67,12.57,.16,.54,.29,1.12,.42,1.68l.2,.85,.1,.42,.12,.7c.26,1.86,.03,3.38-.29,4.72-.66,2.67-1.71,4.8-2.85,6.83-2.32,4.02-5.02,7.45-8.14,10.69l-3.86-2.92c1.9-3.61,3.78-7.39,5.16-11.02,.67-1.81,1.23-3.65,1.4-5.16,.08-.74,.03-1.38-.08-1.62l-.36-1.12c-.15-.46-.28-.92-.47-1.38-1.32-3.69-3-7.41-4.83-11.07-1.8-3.65-3.8-7.36-5.76-10.82l8.36-5.05Z",
    style: {
      fill: "#f3867e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.57,147.51l-4.2,2.23,4.83,5.66s3.02-2.04,3.15-5.16l-3.78-2.73Z",
    style: {
      fill: "#f3867e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.7 153.23 206.88 157.34 212.2 155.4 207.36 149.74 201.7 153.23",
    style: {
      fill: "#f3867e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.02,71.63c-.1,.51-.46,.87-.79,.8-.33-.07-.52-.54-.42-1.04,.1-.51,.46-.87,.79-.8,.33,.07,.52,.54,.42,1.04Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.61,72.51s-1.75,2.7-3.32,3.86c.73,1.02,2.34,.95,2.34,.95l.98-4.81Z",
    style: {
      fill: "#f05859"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.96,90.47l.04-6,7.95,.96s-.14,5.16-4.58,6.68l-3.41-1.64Z",
    style: {
      fill: "#f3867e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.24 80.15 189.84 81.76 189.95 85.43 182 84.47 184.24 80.15",
    style: {
      fill: "#f3867e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.84,81.76l-5.59-1.61-1.09,2.09c.14,3.54,2.3,6.46,5.16,7.76,1.56-2.04,1.62-4.57,1.62-4.57l-.1-3.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.46,69.19c.07,0,.15-.03,.21-.08,.12-.11,.13-.31,.02-.43-1.15-1.24-2.54-1.02-2.6-1.01-.17,.03-.28,.19-.25,.35,.03,.17,.19,.28,.35,.25h0s1.13-.17,2.05,.82c.06,.07,.14,.1,.22,.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.16,80.9c-.92,4.71-1.48,11.24,1.82,14.38,0,0-1.29,4.78-10.04,4.78-9.63,0-4.63-4.19-4.63-4.19,4-1.24,3.97-5.8,3.05-9.46l9.81-5.51Z",
    style: {
      fill: "#f3867e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77,98.44c.86-1.21,.82-5.05-.09-5.73-1.48-1.09-7.8-1.34-16.31,.61,.92,3.72-1.05,5.66-1.05,5.66l17.45-.55Z",
    style: {
      fill: "#006838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.39,315.82c-.65,.14-1.29,.18-1.6-.09-.13-.11-.26-.32-.15-.71,.06-.2,.19-.35,.39-.45,.87-.42,2.87,.4,2.95,.43,.06,.02,.09,.08,.09,.14,0,.06-.03,.12-.09,.14-.31,.15-.95,.39-1.6,.53Zm-1.05-1.03c-.07,.01-.13,.03-.18,.06-.12,.06-.2,.14-.23,.26-.08,.27,.02,.36,.05,.39,.35,.29,1.63,.02,2.54-.34-.61-.22-1.61-.49-2.18-.37Z",
    style: {
      fill: "#006838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.96,315.3s-.05,0-.07,0c-.73-.21-2.29-1.32-2.3-2.05,0-.13,.04-.37,.39-.49,.23-.08,.45-.06,.68,.05,.86,.44,1.4,2.22,1.43,2.3,.02,.05,0,.11-.04,.15-.02,.02-.05,.04-.08,.04Zm-1.82-2.28s-.04,.01-.07,.02c-.19,.07-.19,.16-.18,.2,.01,.43,1.04,1.3,1.79,1.65-.19-.51-.62-1.53-1.17-1.81-.13-.06-.25-.08-.37-.06Z",
    style: {
      fill: "#006838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.84,316.9c-.83,0-1.62-.11-1.89-.49-.09-.13-.17-.35,.01-.67,.1-.18,.26-.3,.48-.36,1.07-.29,3.32,.99,3.42,1.05,.05,.03,.08,.09,.07,.16s-.06,.11-.12,.12c-.41,.08-1.21,.18-1.98,.18Zm-1.02-1.25c-.11,0-.21,.01-.29,.03-.14,.04-.24,.11-.3,.21-.11,.19-.07,.28-.03,.34,.3,.42,1.93,.43,3.13,.26-.6-.31-1.75-.84-2.5-.84Z",
    style: {
      fill: "#006838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.79,316.72s-.04,0-.06-.01c-.78-.35-2.32-1.74-2.2-2.47,.03-.17,.15-.38,.57-.43,.31-.03,.6,.06,.85,.26,.82,.67,.99,2.41,1,2.48,0,.05-.02,.11-.06,.14-.03,.02-.06,.03-.09,.03Zm-1.57-2.61s-.06,0-.09,0c-.27,.03-.29,.14-.3,.17-.07,.44,.98,1.53,1.77,2.01-.08-.51-.31-1.54-.85-1.99-.16-.13-.34-.2-.53-.2Z",
    style: {
      fill: "#006838"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.87 316.57 185.43 316.57 184.79 301.66 191.23 301.66 191.87 316.57",
    style: {
      fill: "#f3867e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.14 313.59 232.85 314.95 226.53 301.06 232.82 299.7 239.14 313.59",
    style: {
      fill: "#f3867e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.24,314.32l7.07-1.53c.26-.06,.52,.07,.63,.31l2.45,5.33c.25,.55-.08,1.2-.68,1.32-2.48,.49-3.71,.61-6.82,1.28-1.91,.41-6.23,1.47-8.87,2.04-2.58,.56-3.55-1.97-2.52-2.44,4.62-2.11,6.55-3.97,7.8-5.7,.23-.31,.56-.53,.94-.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.47,315.83h7.03c.26,0,.49,.18,.55,.44l1.27,5.72c.13,.59-.32,1.16-.93,1.15-2.54-.04-6.2-.19-9.39-.19-3.73,0-6.95,.2-11.32,.2-2.64,0-3.38-2.67-2.27-2.92,5.04-1.1,9.15-1.22,13.51-3.9,.47-.29,1-.5,1.55-.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M211.5,96.74c6.04,1.38,11.01,16.79,11.01,16.79l-12.12,9.24s-4.45-4.19-6.43-11.9c-2.07-8.08,1.37-15.55,7.54-14.13Z",
    style: {
      fill: "#006838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.5,96.74c6.04,1.38,11.01,16.79,11.01,16.79l-12.12,9.24s-4.45-4.19-6.43-11.9c-2.07-8.08,1.37-15.55,7.54-14.13Z",
    style: {
      fill: "#f9c719"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.76,115.13c-1.51,1.63-3.01,3.07-4.56,4.56-.77,.74-1.56,1.47-2.37,2.18l-1.22,1.06-.31,.26c-.15,.13-.33,.28-.52,.43-.4,.3-.84,.65-1.77,1.04-.49,.19-1.12,.44-2.23,.46-.53,0-1.24-.08-1.92-.34-.7-.26-1.37-.7-1.83-1.16-.96-.96-1.25-1.81-1.44-2.37-.18-.58-.23-1-.26-1.36-.06-.71-.02-1.19,.02-1.64,.04-.44,.1-.82,.17-1.18,.27-1.41,.65-2.55,1.06-3.69,.42-1.13,.88-2.21,1.42-3.31,.58-1.17,1.14-2.01,1.7-2.99,2.26-3.78,4.92-7.24,7.74-10.49,2.88-3.23,5.91-6.19,9.39-8.9l3.37,3.47c-2.37,3.17-4.7,6.56-6.85,9.91-2.15,3.37-4.14,6.81-5.86,10.3-.4,.86-.88,1.81-1.16,2.53-.32,.79-.62,1.64-.86,2.47-.24,.82-.43,1.68-.52,2.31-.02,.15-.03,.29-.03,.36,0,.07,.02,.11,0-.08,0-.11-.02-.26-.12-.6-.11-.32-.29-.92-1.06-1.7-.37-.37-.93-.75-1.51-.96-.56-.22-1.14-.28-1.54-.28-.85,.02-1.23,.19-1.48,.28-.45,.19-.46,.25-.45,.23l.35-.32,1.1-1.01,2.19-2.05c1.45-1.37,2.91-2.82,4.28-4.17l7.05,6.75Z",
    style: {
      fill: "#f3867e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.33,108.07c3.28,3.24,4.35,9.15,4.6,14.29l-.53,.41s-4.45-4.2-6.44-11.91c-.12-.48-.23-.96-.32-1.44l2.68-1.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.36,103.2c-1.32,6.96-2.14,21.25,1.68,49.54h34.45c.24-5.29-3.09-31.08,2.02-56,0,0-5.9-1.18-11.53-1.46-4.4-.21-10.77-.35-14.64,0-1.62,.15-3.2,.38-4.61,.63-3.72,.66-6.65,3.57-7.36,7.28Z",
    style: {
      fill: "#006838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.36,103.2c-1.32,6.96-2.14,21.25,1.68,49.54h34.45c.24-5.29-3.09-31.08,2.02-56,0,0-5.9-1.18-11.53-1.46-4.4-.21-10.77-.35-14.64,0-1.62,.15-3.2,.38-4.61,.63-3.72,.66-6.65,3.57-7.36,7.28Z",
    style: {
      fill: "#f9c719"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.63,113.48l-6.22-1.49c-.19,3.77-.21,8.44,.07,14.22,2.87-3.26,6.52-8.35,6.15-12.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "184.79 301.66 185.12 309.35 191.56 309.35 191.23 301.66 184.79 301.66",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.82 299.7 226.53 301.06 229.79 308.22 236.08 306.86 232.82 299.7",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.22,74.01c-1.65,6.17-2.31,9.87-6.12,12.44-5.73,3.86-12.87-.57-13.09-7.11-.2-5.89,2.54-15,9.16-16.24,6.53-1.23,11.7,4.74,10.04,10.92Z",
    style: {
      fill: "#f3867e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.76,74.24c-.31-.83-1.73-7.21-.39-8.86,1.34-1.66,16.58-.46,18.84,1.75,3.74,3.68,1.15,6.97-2.95,11.2-3.08,3.19-3.2,6.78-4.75,7.31-2.72,.92-6.94,.06-7.79-2.85-.85-2.91-2.96-8.55-2.96-8.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.36,59.88c-5.39-2.29-15.49,.24-20.95-1.07-.19,2.83,1.51,7.35,6.96,8.57,0,0,7.74,1.51,13.74,1.27,5.99-.24,4.82-6.82,.25-8.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.2,67.33s3.33,.38,5.7-1.09c1.01,2.43-4.53,3.1-5.7,1.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.7,74.5c-.1,1.67-.88,3.24-1.81,4.27-1.4,1.55-2.87,.58-3.12-1.3-.22-1.7,.24-4.54,1.95-5.4,1.69-.84,3.09,.51,2.97,2.43Z",
    style: {
      fill: "#f3867e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.26,152.74s7.31,49.22,11.32,67.66c4.39,20.19,27.96,87,27.96,87l11.53-2.5s-16.48-54.44-20.16-82.68c-2.83-21.68-8.42-69.49-8.42-69.49h-22.23Z",
    style: {
      fill: "#2e3192"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.78,303.56s2.15,4.17,2.15,4.17l12.97-2.81-1.09-3.9-14.03,2.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.88,170.28c8.45,1.66,7.56,33.18,6.54,49.39-2.44-11.46-6.01-33.51-8.44-49.16,.56-.28,1.19-.37,1.9-.23Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.04,152.74s-.89,48.16-.19,67.8c.73,20.43,7.86,87.32,7.86,87.32h10.91s.4-65.7,.89-85.76c.53-21.87,3.17-69.36,3.17-69.36h-22.64Z",
    style: {
      fill: "#2e3192"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.62,303.51c-.05,0,.62,4.53,.62,4.53h13.27l.36-4.04-14.25-.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M186.86,105.31c3.09,8.32-15.06,18.13-15.06,18.13l-7.85-10.1s5.24-10.43,11.67-15.13c7.94-5.81,8.89,.77,11.24,7.1Z",
    style: {
      fill: "#006838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.86,105.31c3.09,8.32-15.06,18.13-15.06,18.13l-7.85-10.1s5.24-10.43,11.67-15.13c7.94-5.81,8.89,.77,11.24,7.1Z",
    style: {
      fill: "#f9c719"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.94,
    cy: 21.06,
    rx: 33.04,
    ry: 21.06,
    style: {
      fill: "#006838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.01,31.66c-1.84,0-3.63-.55-5.18-1.61-2.09-1.42-3.47-3.58-3.91-6.07-.82-4.77,2.34-9.52,7.06-10.59h0c3.88-.88,7.83,.77,9.91,4.14l21.21-4.38c1.72-.35,3.47,.67,3.89,2.29,.22,.86,.09,1.75-.38,2.5-.47,.75-1.2,1.26-2.07,1.44l-.56,.12c-.17,.03-.3,.13-.38,.28-.08,.15-.09,.32-.03,.48l.37,.97c.25,.66,.02,1.4-.56,1.76-.45,.28-.76,.77-.82,1.29-.08,.65-.51,1.15-1.1,1.27l-.44,.09c-.59,.12-1.19-.16-1.51-.73-.38-.66-1.14-1-1.89-.85-.75,.16-1.32,.77-1.41,1.53-.08,.65-.51,1.15-1.1,1.27l-.43,.09c-.59,.12-1.19-.16-1.51-.73-.27-.46-.74-.78-1.27-.86-.68-.1-1.19-.69-1.22-1.39l-.04-1.04c0-.17-.08-.32-.22-.42-.13-.1-.29-.14-.46-.11l-6.76,1.4c-.57,3.83-3.46,6.9-7.28,7.69-.63,.13-1.26,.19-1.89,.19Zm-1.83-17.38c-4.25,.97-7.1,5.25-6.36,9.54,.39,2.25,1.64,4.19,3.52,5.47,1.88,1.28,4.15,1.74,6.38,1.28,3.54-.73,6.19-3.63,6.6-7.22l.04-.33,7.4-1.53c.43-.09,.87,.02,1.21,.28,.34,.27,.55,.67,.57,1.11l.04,1.04c0,.26,.2,.49,.44,.52,.82,.12,1.52,.6,1.93,1.31,.1,.17,.29,.34,.54,.29l.43-.09c.24-.05,.36-.28,.38-.48,.14-1.15,1-2.08,2.14-2.32,1.14-.23,2.29,.28,2.87,1.28,.1,.17,.29,.34,.54,.29l.44-.09c.24-.05,.35-.28,.38-.48,.1-.82,.55-1.53,1.25-1.97,.2-.13,.29-.41,.19-.65l-.37-.97c-.16-.41-.13-.86,.08-1.24,.21-.38,.57-.65,1-.74l.56-.12c.62-.13,1.14-.49,1.48-1.03,.33-.54,.43-1.17,.27-1.78-.3-1.15-1.57-1.88-2.82-1.62l-21.86,4.51-.16-.29c-1.83-3.2-5.48-4.8-9.09-3.98h0Zm1.84,14c-1.13,0-2.24-.33-3.21-.97-1.31-.86-2.2-2.18-2.52-3.71-.32-1.54-.02-3.1,.84-4.41,.86-1.31,2.18-2.2,3.71-2.52,1.54-.32,3.1-.02,4.41,.84,1.31,.86,2.2,2.18,2.52,3.72,.32,1.53,.02,3.1-.84,4.41-.86,1.31-2.18,2.2-3.72,2.52h0c-.4,.08-.8,.12-1.2,.12Zm.03-10.82c-.34,0-.68,.03-1.02,.1-1.29,.27-2.41,1.02-3.13,2.12-.73,1.1-.98,2.43-.71,3.72,.27,1.29,1.02,2.41,2.13,3.13,1.1,.73,2.43,.98,3.72,.71h0c1.3-.27,2.41-1.02,3.14-2.13,.73-1.1,.98-2.42,.71-3.72-.27-1.3-1.02-2.41-2.12-3.14-.81-.54-1.75-.81-2.71-.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.03,
    cy: 47.55,
    rx: 10.86,
    ry: 6.92,
    style: {
      fill: "#006838",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.76,
    cy: 54.47,
    rx: 4.46,
    ry: 2.84,
    style: {
      fill: "#006838",
      opacity: 0.3
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassword);
export default __webpack_public_path__ + "static/media/forgot-password.13a5d575aa112a5ed4bbf3d3e3243c85.svg";
export { ForwardRef as ReactComponent };